import { atom } from "recoil";

export const goUpFunctionsState = atom<{
  blocks: undefined | (() => void);
  products: undefined | (() => void);
}>({
  key: "goUpFunctionsState",
  default: { blocks: undefined, products: undefined },
});
